import React from 'react';
import { motion } from 'framer-motion';
export function ProductMockup({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`relative w-full max-w-lg mx-auto aspect-square ${className}`} data-id="element-118">
      {/* Background decorative blobs */}
      <motion.div animate={{
      scale: [1, 1.05, 1],
      rotate: [0, 2, -2, 0]
    }} transition={{
      duration: 6,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="absolute inset-0 bg-pastel-yellowLight rounded-full opacity-50 blur-3xl" data-id="element-119" />

      {/* Tablet Mockup */}
      <motion.div initial={{
      y: 20,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} transition={{
      duration: 0.8,
      delay: 0.2
    }} className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-3/4 h-3/4 bg-white rounded-3xl shadow-soft border-8 border-slate-100 overflow-hidden z-10 flex flex-col" data-id="element-120">
        <div className="h-12 bg-pastel-blueLight flex items-center px-4 border-b border-slate-100" data-id="element-121">
          <div className="flex gap-1.5" data-id="element-122">
            <div className="w-3 h-3 rounded-full bg-pastel-coral" data-id="element-123" />
            <div className="w-3 h-3 rounded-full bg-pastel-yellow" data-id="element-124" />
            <div className="w-3 h-3 rounded-full bg-pastel-mint" data-id="element-125" />
          </div>
          <div className="mx-auto w-1/3 h-4 bg-white rounded-full opacity-50" data-id="element-126" />
        </div>
        <div className="flex-1 p-6 flex flex-col gap-4 bg-slate-50" data-id="element-127">
          <div className="w-1/2 h-8 bg-pastel-lilac rounded-lg" data-id="element-128" />
          <div className="flex gap-4" data-id="element-129">
            <div className="w-1/3 aspect-square bg-pastel-mintLight rounded-xl flex items-center justify-center text-4xl" data-id="element-130">
              A
            </div>
            <div className="w-1/3 aspect-square bg-pastel-yellowLight rounded-xl flex items-center justify-center text-4xl" data-id="element-131">
              B
            </div>
            <div className="w-1/3 aspect-square bg-pastel-blueLight rounded-xl flex items-center justify-center text-4xl" data-id="element-132">
              C
            </div>
          </div>
          <div className="w-full h-4 bg-slate-200 rounded-full mt-auto" data-id="element-133" />
          <div className="w-4/5 h-4 bg-slate-200 rounded-full" data-id="element-134" />
        </div>
      </motion.div>

      {/* Floating Worksheets */}
      <motion.div initial={{
      x: -40,
      y: 40,
      opacity: 0,
      rotate: -15
    }} animate={{
      x: 0,
      y: 0,
      opacity: 1,
      rotate: -10
    }} transition={{
      duration: 0.8,
      delay: 0.4
    }} className="absolute bottom-10 left-0 w-1/2 aspect-[3/4] bg-white rounded-xl shadow-card border border-slate-100 p-4 z-20" data-id="element-135">
        <div className="w-full h-full border-2 border-dashed border-pastel-mint rounded-lg flex flex-col items-center justify-center gap-2" data-id="element-136">
          <div className="w-12 h-12 rounded-full border-4 border-pastel-mint flex items-center justify-center text-pastel-mint font-bold text-xl" data-id="element-137">
            1
          </div>
          <div className="w-3/4 h-2 bg-pastel-mintLight rounded-full" data-id="element-138" />
          <div className="w-1/2 h-2 bg-pastel-mintLight rounded-full" data-id="element-139" />
        </div>
      </motion.div>

      <motion.div initial={{
      x: 40,
      y: -40,
      opacity: 0,
      rotate: 15
    }} animate={{
      x: 0,
      y: 0,
      opacity: 1,
      rotate: 12
    }} transition={{
      duration: 0.8,
      delay: 0.6
    }} className="absolute top-10 right-0 w-2/5 aspect-[3/4] bg-white rounded-xl shadow-card border border-slate-100 p-4 z-0" data-id="element-140">
        <div className="w-full h-full border-2 border-pastel-lilac rounded-lg p-2 flex flex-col gap-2" data-id="element-141">
          <div className="w-full h-1/2 bg-pastel-lilacLight rounded-md" data-id="element-142" />
          <div className="w-full h-2 bg-slate-100 rounded-full" data-id="element-143" />
          <div className="w-full h-2 bg-slate-100 rounded-full" data-id="element-144" />
          <div className="w-2/3 h-2 bg-slate-100 rounded-full" data-id="element-145" />
        </div>
      </motion.div>

      {/* Floating Pencil */}
      <motion.div animate={{
      y: [-5, 5, -5]
    }} transition={{
      duration: 4,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="absolute top-1/4 -left-4 w-8 h-32 bg-pastel-yellow rounded-sm rotate-45 z-30 shadow-lg flex flex-col" data-id="element-146">
        <div className="h-4 w-full bg-pastel-coral rounded-t-sm" data-id="element-147" />
        <div className="h-2 w-full bg-slate-200" data-id="element-148" />
        <div className="flex-1 w-full bg-pastel-yellow flex justify-center" data-id="element-149">
          <div className="w-1 h-full bg-white opacity-30" data-id="element-150" />
        </div>
        <div className="h-6 w-full bg-[#E8C396] clip-triangle relative" data-id="element-151">
          <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-2 h-2 bg-slate-800 rounded-b-sm" data-id="element-152" />
        </div>
      </motion.div>
    </div>;
}